import { BaseCache } from "@/utils/cache/base-cache"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"

export const POOL_RENEC_CACHE_KEY = `POOLS_${BlockchainNetwork.RENEC}`
export const POOL_SOLANA_CACHE_KEY = `POOLS_${BlockchainNetwork.SOLANA}`
export const TOKEN_INFOS_CACHE_KEY = "TOKEN_INFOS"

export const poolCache = new BaseCache()

export const tokenInfosCache = new BaseCache()
